/** Общий «тик» для всех живых таймеров на странице — один setInterval вместо сотни. */
import { ref } from 'vue';

export const now = ref(Date.now());
let started = false;

export function useNow() {
  if (!started) {
    started = true;
    window.setInterval(() => (now.value = Date.now()), 1000);
  }
  return now;
}
